function updateCustomTimer() {
    const timerNow = new Date();
    // utilizzare qui sotto per timer evergreen a 3 giorni
  
    /*const targetDate = new Date(timerNow);
    targetDate.setDate(targetDate.getDate() + 3); 
    targetDate.setHours(0, 0, 0, 0);
    */
    
  const targetDate = new Date("2024-02-14T23:59:00+01:00")

  const timeDifference = targetDate - timerNow;
  
  // eliminare qui sotto per timer perenne
  if (timeDifference < 0) {
        // Se la data di scadenza è passata, mostriamo 00:00:00:00
        document.querySelector('#timer-days').textContent = '00';
        document.querySelector('#timer-hours').textContent = '00';
        document.querySelector('#timer-minutes').textContent = '00';
        document.querySelector('#timer-seconds').textContent = '00';
        return;
    }

    const timerDays = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const timerHours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const timerMinutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
    const timerSeconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

    document.querySelector('#timer-days').textContent = timerDays.toString().padStart(2, '0');
    document.querySelector('#timer-hours').textContent = timerHours.toString().padStart(2, '0');
    document.querySelector('#timer-minutes').textContent = timerMinutes.toString().padStart(2, '0');
    document.querySelector('#timer-seconds').textContent = timerSeconds.toString().padStart(2, '0');
}

updateCustomTimer();
setInterval(updateCustomTimer, 1000);